/* SugarSteady product page interactions. Vegan LifeMoss. */
(function () {
  'use strict';
  if (window.__ssPdpLoaded) return;
  window.__ssPdpLoaded = true;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function fmt(cents, format) {
    var f = format || '${{amount}}';
    var v = (Math.round(cents) / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }

  function openCart() {
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: s, id: null });
        } else { drawer.open(); }
      }).catch(function () { drawer.open(); });
      return;
    }
    window.location.href = root + 'cart';
  }

  function trackKlaviyo(res) {
    try {
      var list = (res && res.items) || [res];
      var q = (window.klaviyo && typeof window.klaviyo.push === 'function') ? window.klaviyo : (window._learnq = window._learnq || []);
      list.forEach(function (it) {
        if (!it || !it.product_id) return;
        q.push(['track', 'Added to Cart', {
          ProductName: it.product_title, ProductID: it.product_id, VariantID: it.variant_id, SKU: it.sku,
          Quantity: it.quantity, Price: (it.final_line_price || it.price) / 100, ItemPrice: it.price / 100,
          URL: location.origin + (it.url || ''), ImageURL: it.image || ''
        }]);
      });
    } catch (e) {}
  }

  function addToCart(items, btn) {
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; }
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        trackKlaviyo(res);
        if (btn) { btn.disabled = false; if (label !== null && btn.dataset.ssAddedLabel) { btn.innerHTML = btn.dataset.ssAddedLabel; setTimeout(function () { btn.innerHTML = label; }, 2500); } }
        openCart();
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; }
        alertMsg((err && (err.description || err.message)) || 'Sorry, that could not be added to your cart.');
      });
  }

  function alertMsg(text) {
    var el = document.createElement('div');
    el.setAttribute('role', 'alert');
    el.textContent = text;
    el.style.cssText = 'position:fixed;left:50%;bottom:90px;transform:translateX(-50%);z-index:2147483002;background:#222;color:#fff;padding:12px 18px;border-radius:10px;font:600 14px Manrope,Arial,sans-serif;max-width:90vw';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 4000);
  }

  /* ---------- Buy box ---------- */
  function initBuybox(box) {
    var cfgEl = box.querySelector('[data-ss-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var state = { pack: 1, sub: false, planIdx: 0 };
    var q = function (s) { return box.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(box.querySelectorAll(s)); };

    function subUnitFor() {
      var p = cfg.plans[state.planIdx];
      return p ? p.price : cfg.subUnit;
    }
    function priceFor(n, isSub) {
      var u = isSub ? subUnitFor() : cfg.unit;
      var o = (!isSub || cfg.subBundle) ? (cfg.off[n - 1] || 0) : 0;
      return u * n * (100 - o) / 100;
    }
    function render() {
      var n = state.pack, now = priceFor(n, state.sub);
      var set = function (sel, txt) { var e = q(sel); if (e) e.textContent = txt; };
      set('[data-ss-now]', fmt(now, cfg.moneyFormat));
      set('[data-ss-per]', fmt(now / ((cfg.days || 30) * n), cfg.moneyFormat));
      set('[data-ss-sub-price]', fmt(priceFor(n, true), cfg.moneyFormat));
      set('[data-ss-full]', fmt(cfg.unit * n, cfg.moneyFormat));
      set('[data-ss-once-price]', fmt(priceFor(n, false), cfg.moneyFormat));
      var onceFull = q('[data-ss-once-full]'), save = q('[data-ss-save]'), off = cfg.off[n - 1] || 0;
      var subFull = q('[data-ss-full]'); if (subFull) subFull.hidden = priceFor(n, true) >= cfg.unit * n;
      if (onceFull) { onceFull.textContent = fmt(cfg.unit * n, cfg.moneyFormat); onceFull.hidden = !off; }
      if (save) { save.textContent = 'SAVE ' + off + '%'; save.hidden = !off; }
      qa('[data-ss-pack-price]').forEach(function (e) { var k = +e.getAttribute('data-ss-pack-price'); e.textContent = fmt(priceFor(k, state.sub), cfg.moneyFormat); });
      qa('[data-ss-pack]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-ss-pack') === n ? 'true' : 'false'); });
      qa('[data-ss-opt]').forEach(function (o) { o.classList.toggle('is-on', (o.getAttribute('data-ss-opt') === 'sub') === state.sub); });
      var extra = q('[data-ss-sub-extra]'); if (extra) extra.hidden = !state.sub;
      qa('[data-ss-mode]').forEach(function (r) { r.checked = (r.value === 'sub') === state.sub; });
      set('[data-ss-bar-price]', fmt(now, cfg.moneyFormat));
      set('[data-ss-bar-label]', n + ' Bottle' + (n > 1 ? 's' : '') + (state.sub ? ' · Subscribe & Save' : ' · One-time'));
      qa('[data-ss-bar-img]').forEach(function (i) { i.hidden = +i.getAttribute('data-ss-bar-img') !== n; });
    }

    qa('[data-ss-pack]').forEach(function (b) { b.addEventListener('click', function () { state.pack = +b.getAttribute('data-ss-pack'); render(); }); });
    qa('[data-ss-mode]').forEach(function (r) { r.addEventListener('change', function () { state.sub = r.value === 'sub'; render(); }); });
    var subBox = q('[data-ss-opt="sub"]');
    if (subBox) subBox.addEventListener('click', function (e) { if (e.target.closest('[data-ss-code],select')) return; if (!state.sub) { state.sub = true; render(); } });
    var planSel = q('[data-ss-plan]');
    if (planSel) planSel.addEventListener('change', function () { state.planIdx = planSel.selectedIndex; render(); });

    qa('[data-ss-atc]').forEach(function (btn) {
      btn.dataset.ssAddedLabel = 'ADDED ✓';
      btn.addEventListener('click', function () {
        var item = { id: cfg.variantId, quantity: state.pack };
        if (state.sub && planSel) item.selling_plan = +planSel.value;
        addToCart([item], btn);
      });
    });

    var code = q('[data-ss-code]');
    if (code) code.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var c = code.getAttribute('data-ss-code');
      fetch(root + 'discount/' + encodeURIComponent(c), { credentials: 'same-origin' }).finally(function () {
        code.classList.add('is-applied'); code.setAttribute('aria-pressed', 'true'); code.textContent = c + ' APPLIED ✓';
        try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (err) {}
      });
    });

    // gallery
    var slides = qa('[data-slide]'), dots = qa('[data-ss-dot]'), thumbs = qa('[data-ss-thumb]'), badge = q('[data-ss-badge]'), cur = 0;
    function show(i) { var dir = i < cur ? -1 : 1;
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      for (var g = 0; g < slides.length && slides[cur].__off; g++) cur = (cur + dir + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== cur; });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      if (badge) badge.hidden = slides.some(function (s, k) { return k < cur && !s.__off; });
    }
    var prev = q('[data-ss-prev]'), next = q('[data-ss-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var main = q('.ss-gal__main'), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
    }
    show(0);

    // sizes (variants) + gallery filtering by size and pack
    var gm = q('[data-ss-galmeta]'), meta = [], curSize = '';
    try { meta = gm ? JSON.parse(gm.textContent) : []; } catch (e) { meta = []; }
    function packSlide(n) { for (var k = 0; k < meta.length; k++) { var m = meta[k]; if (m && String(m.p) === String(n) && (!m.s || m.s === curSize) && slides[k] && !slides[k].__off) return k; } return -1; }
    function applySize(btn) {
      var d; try { d = JSON.parse(btn.getAttribute('data-cfg')); } catch (e) { return; }
      curSize = btn.getAttribute('data-ss-vsize');
      ['variantId', 'available', 'unit', 'subUnit', 'compareUnit', 'days', 'plans'].forEach(function (k) { if (d[k] !== undefined) cfg[k] = d[k]; });
      qa('.ss-vsize').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      (d.imgs || []).forEach(function (u, k) {
        if (!u) return;
        var pi = q('[data-ss-pack="' + (k + 1) + '"] img'); if (pi) { pi.removeAttribute('srcset'); pi.src = u; }
        var bi = q('[data-ss-bar-img="' + (k + 1) + '"]'); if (bi) { bi.removeAttribute('srcset'); bi.src = u; }
      });
      qa('[data-ss-pack-price]').forEach(function (e) { var n = +e.getAttribute('data-ss-pack-price'); e.parentNode.childNodes.forEach(function (nd) { if (nd.nodeType === 3) nd.nodeValue = nd.nodeValue.replace(/\d+ days/, n * (cfg.days || 30) + ' days'); }); });
      if (badge && d.badge) badge.childNodes.forEach(function (nd) { if (nd.nodeType === 3 && nd.nodeValue.trim()) nd.nodeValue = d.badge; });
      meta.forEach(function (m, k) { var off = !!(m && m.s && m.s !== curSize); if (slides[k]) slides[k].__off = off; if (dots[k]) dots[k].style.display = off ? 'none' : ''; if (thumbs[k]) thumbs[k].style.display = off ? 'none' : ''; });
      var ps = packSlide(state.pack); cur = -1; show(ps > -1 ? ps : 0);
      render();
    }
    qa('.ss-vsize').forEach(function (b) { b.addEventListener('click', function () { applySize(b); }); });
    qa('[data-ss-pack]').forEach(function (b) { b.addEventListener('click', function () { var ps = packSlide(state.pack); if (ps > -1) show(ps); }); });
    var sizeOn = q('.ss-vsize[aria-pressed="true"]') || q('.ss-vsize');
    if (sizeOn) applySize(sizeOn);

    // tabs
    var tabs = qa('[data-ss-tab]'), panels = qa('[data-ss-panel]');
    tabs.forEach(function (t) { t.addEventListener('click', function () {
      var k = t.getAttribute('data-ss-tab');
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-ss-panel') !== k; });
    }); });

    // pairs well with
    var cards = qa('[data-ss-xs-card]'), xdots = qa('[data-ss-xs-dot]'), xi = 0;
    function showXs(i) {
      if (!cards.length) return;
      xi = (i + cards.length) % cards.length;
      cards.forEach(function (c, k) { c.hidden = k !== xi; });
      xdots.forEach(function (d, k) { d.setAttribute('aria-current', k === xi ? 'true' : 'false'); });
    }
    var xp = q('[data-ss-xs-prev]'), xn = q('[data-ss-xs-next]');
    if (xp) xp.addEventListener('click', function () { showXs(xi - 1); });
    if (xn) xn.addEventListener('click', function () { showXs(xi + 1); });
    xdots.forEach(function (d, k) { d.addEventListener('click', function () { showXs(k); }); });
    cards.forEach(function (c) {
      var sel = c.querySelector('[data-ss-xs-qty]'), priceEl = c.querySelector('[data-ss-xs-price]'), base = +c.getAttribute('data-price');
      var coff = (c.getAttribute('data-off') || '0,0,0').split(',').map(Number);
      function upd() {
        var n = +sel.value, off = coff[n - 1] || 0, now = base * n * (100 - off) / 100;
        priceEl.innerHTML = fmt(now, cfg.moneyFormat) + (off ? ' <s>' + fmt(base * n, cfg.moneyFormat) + '</s>' : '');
      }
      if (sel) sel.addEventListener('change', upd);
      var add = c.querySelector('[data-ss-xs-add]');
      if (add) add.addEventListener('click', function () { addToCart([{ id: +c.getAttribute('data-variant'), quantity: sel ? +sel.value : 1 }], add); });
    });

    // floating bar: show only after scrolling past the main button (Ritual-style)
    var bar = q('[data-ss-bar]'), mainBtn = q('#ss-main-atc');
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      var pastBtn = false, footSeen = false;
      var lifted = [], liftTimer = null;
      var dropFloaters = function () {
        lifted.forEach(function (el) { el.style.transform = el.__ssPrevTransform || ''; el.style.transition = el.__ssPrevTransition || ''; delete el.__ssLifted; });
        lifted = [];
      };
      var liftFloaters = function () {
        var inner = bar.querySelector('.ss-bar__in');
        if (!inner) return;
        var br = inner.getBoundingClientRect();
        if (!br.height) return;
        var vh = window.innerHeight, found = [];
        for (var x = br.left + 6; x < br.right; x += 18) {
          [br.top + 4, br.top + br.height / 2, br.bottom - 4].forEach(function (y) {
            (document.elementsFromPoint ? document.elementsFromPoint(x, y) : []).forEach(function (el) {
              while (el && el !== document.body && getComputedStyle(el).position !== 'fixed') el = el.parentElement;
              if (el && el !== document.body && found.indexOf(el) < 0) found.push(el);
            });
          });
        }
        found.forEach(function (el) {
          if (el === bar || bar.contains(el) || el.contains(bar) || el.__ssLifted) return;
          var cs = getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden') return;
          var r = el.getBoundingClientRect();
          if (!r.width || !r.height || r.height > vh * 0.5 || r.top < vh * 0.5) return;
          var overlaps = r.bottom > br.top - 4 && r.left < br.right && r.right > br.left;
          if (!overlaps) return;
          var lift = Math.ceil(r.bottom - br.top + 10);
          el.__ssPrevTransform = el.style.transform; el.__ssPrevTransition = el.style.transition;
          el.style.transition = 'transform .3s ease';
          el.style.transform = (el.__ssPrevTransform ? el.__ssPrevTransform + ' ' : '') + 'translateY(-' + lift + 'px)';
          el.__ssLifted = true; lifted.push(el);
        });
      };
      var sync = function () {
        var on = pastBtn && !footSeen;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        clearInterval(liftTimer);
        if (on) { setTimeout(liftFloaters, 320); liftTimer = setInterval(liftFloaters, 1500); } else { dropFloaters(); }
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0]; pastBtn = !e.isIntersecting && e.boundingClientRect.top < 0; sync();
      }).observe(mainBtn);
      var foot = document.querySelector('.ss-foot') || document.querySelector('footer');
      if (foot) new IntersectionObserver(function (entries) { footSeen = entries[0].isIntersecting; sync(); }).observe(foot);
    }

    // expose for other sections (Give It 90 Days, drawers)
    window.ssBuybox = {
      add: function (qty, sub, planIndex, btn) {
        var item = { id: cfg.variantId, quantity: qty };
        if (sub && cfg.plans.length) {
          var p = cfg.plans[Math.min(Math.max((planIndex || 1) - 1, 0), cfg.plans.length - 1)];
          item.selling_plan = p.id;
        }
        return addToCart([item], btn);
      },
      current: function (btn) {
        var item = { id: cfg.variantId, quantity: state.pack };
        if (state.sub && planSel) item.selling_plan = +planSel.value;
        return addToCart([item], btn);
      },
      g90Plan: cfg.g90Plan,
      available: cfg.available
    };
    render();
  }

  /* ---------- Benefit drawers ---------- */
  function initDrawers(sec) {
    var overlay = sec.querySelector('[data-ss-overlay]');
    var drawers = sec.querySelectorAll('[data-ss-drawer]');
    var lastBtn = null;
    function close() {
      overlay.hidden = true;
      drawers.forEach(function (d) { d.hidden = true; });
      document.documentElement.style.overflow = '';
      if (lastBtn) lastBtn.focus();
    }
    sec.querySelectorAll('[data-ss-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = sec.querySelector('[data-ss-drawer="' + b.getAttribute('data-ss-open') + '"]');
        if (!d) return;
        lastBtn = b; overlay.hidden = false; d.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var c = d.querySelector('[data-ss-close]'); if (c) c.focus();
      });
    });
    if (overlay) overlay.addEventListener('click', close);
    sec.querySelectorAll('[data-ss-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) close(); });
    sec.querySelectorAll('[data-ss-drawer-add]').forEach(function (b) {
      b.dataset.ssAddedLabel = 'ADDED TO CART ✓';
      b.addEventListener('click', function () { if (window.ssBuybox) window.ssBuybox.current(b); });
    });
  }

  /* ---------- Facts picker ---------- */
  function initFacts(sec) {
    var rows = sec.querySelectorAll('[data-ss-fact]'), cards = sec.querySelectorAll('[data-ss-fx]'), overlay = sec.querySelector('[data-ss-fx-overlay]');
    var phone = window.matchMedia('(max-width: 760px)'), lastRow = null;
    function closeSheet() {
      cards.forEach(function (c) { c.classList.remove('is-sheet'); });
      if (overlay) overlay.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastRow) lastRow.focus();
    }
    rows.forEach(function (r) { r.addEventListener('click', function () {
      var k = r.getAttribute('data-ss-fact');
      rows.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-ss-fact') === k ? 'true' : 'false'); });
      cards.forEach(function (c) { c.hidden = c.getAttribute('data-ss-fx') !== k; c.classList.remove('is-sheet'); });
      if (phone.matches) {
        var card = sec.querySelector('[data-ss-fx="' + k + '"]');
        if (!card) return;
        lastRow = r; card.classList.add('is-sheet'); card.scrollTop = 0;
        if (overlay) overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var x = card.querySelector('[data-ss-fx-close]'); if (x) x.focus();
      }
    }); });
    if (overlay) overlay.addEventListener('click', closeSheet);
    sec.querySelectorAll('[data-ss-fx-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeSheet(); });
    var onChange = function () { if (!phone.matches) closeSheet(); };
    if (phone.addEventListener) phone.addEventListener('change', onChange);
  }

  /* ---------- Timeline ---------- */
  function initTimeline(sec) {
    var cols = sec.querySelectorAll('[data-ss-tl]'), prev = sec.querySelector('[data-ss-tl-prev]'), next = sec.querySelector('[data-ss-tl-next]'), scroller = sec.querySelector('.ss-tl__scroll'), cur = 0;
    function reveal() {
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 2) return;
      var col = cols[cur], cards = col.offsetParent;
      var left = col.offsetLeft + (cards && cards !== scroller ? cards.offsetLeft : 0);
      var target = left - (scroller.clientWidth - col.offsetWidth) / 2;
      scroller.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }
    function show(i, move) {
      cur = Math.max(0, Math.min(cols.length - 1, i));
      cols.forEach(function (c, k) { c.classList.toggle('is-on', k === cur); var b = c.querySelector('button'); if (b) b.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur === cols.length - 1;
      if (move) setTimeout(reveal, 380);
    }
    cols.forEach(function (c, k) { var b = c.querySelector('button'); if (b) b.addEventListener('click', function () { show(k, true); }); });
    if (prev) prev.addEventListener('click', function () { show(cur - 1, true); });
    if (next) next.addEventListener('click', function () { show(cur + 1, true); });
    show(0);
  }

  /* ---------- Real results: slow auto-scroll ---------- */
  function initResults(row) {
    if (!row.hasAttribute('data-auto')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = Array.prototype.slice.call(row.children);
    if (items.length < 2) return;
    // Infinite loop: append one copy of the cards and wrap around seamlessly.
    items.forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-ss-clone', '');
      c.removeAttribute('data-shopify-editor-block');
      c.querySelectorAll('a,button,[tabindex]').forEach(function (n) { n.setAttribute('tabindex', '-1'); });
      c.querySelectorAll('img').forEach(function (i) { i.loading = 'eager'; });
      row.appendChild(c);
    });
    row.style.scrollSnapType = 'none';
    var firstClone = row.children[items.length];
    function loopW() { return firstClone.offsetLeft - items[0].offsetLeft; }
    function wrap() { var w = loopW(); if (w > 0) { while (pos >= w) pos -= w; while (pos < 0) pos += w; } }
    var speed = 0.45, pos = row.scrollLeft, paused = false, visible = false, resumeT = null, raf = null;
    function pause() { paused = true; clearTimeout(resumeT); }
    function resumeSoon(ms) { clearTimeout(resumeT); resumeT = setTimeout(function () { pos = row.scrollLeft; wrap(); row.scrollLeft = pos; paused = false; }, ms || 2500); }
    row.addEventListener('scroll', function () {
      if (!paused) return;
      var w = loopW(); if (w <= 0) return;
      if (row.scrollLeft >= w) row.scrollLeft -= w;
      else if (row.scrollLeft <= 0) row.scrollLeft += w;
    }, { passive: true });
    function step() {
      raf = null;
      if (!visible) return;
      if (!paused) { pos += speed; wrap(); row.scrollLeft = pos; }
      raf = requestAnimationFrame(step);
    }
    row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(); });
    row.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resumeSoon(800); });
    row.addEventListener('touchstart', pause, { passive: true });
    row.addEventListener('touchend', function () { resumeSoon(3000); }, { passive: true });
    row.addEventListener('focusin', pause);
    row.addEventListener('focusout', function () { resumeSoon(1500); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible && !raf) { pos = row.scrollLeft; raf = requestAnimationFrame(step); } }).observe(row);
    } else { visible = true; raf = requestAnimationFrame(step); }
  }

  /* ---------- Give It 90 Days ---------- */
  function initG90(sec) {
    var b = sec.querySelector('[data-ss-g90]');
    if (!b) return;
    b.dataset.ssAddedLabel = b.getAttribute('data-added') || 'ADDED ✓';
    b.addEventListener('click', function () {
      if (!window.ssBuybox) return;
      window.ssBuybox.add(+b.getAttribute('data-qty') || 3, true, +b.getAttribute('data-plan') || window.ssBuybox.g90Plan, b);
    });
  }

  /* ---------- More ways ---------- */
  function initMore(sec) {
    var fmtStr = sec.getAttribute('data-money') || '${{amount}}';
    var off = (sec.getAttribute('data-off') || '0,5,10').split(',').map(Number);
    sec.querySelectorAll('[data-ss-mcard]').forEach(function (card) {
      var coff = card.getAttribute('data-off') ? card.getAttribute('data-off').split(',').map(Number) : off;
      var base = +card.getAttribute('data-price'), size = 1, priceEl = card.querySelector('[data-ss-mprice]'), btn = card.querySelector('[data-ss-madd]');
      card.querySelectorAll('[data-ss-size]').forEach(function (s) { s.addEventListener('click', function () {
        size = +s.getAttribute('data-ss-size');
        card.querySelectorAll('[data-ss-size]').forEach(function (x) { x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
        var o = coff[size - 1] || 0;
        priceEl.innerHTML = '<b>' + fmt(base * size * (100 - o) / 100, fmtStr) + '</b>' + (o ? '<s>' + fmt(base * size, fmtStr) + '</s>' : '');
      }); });
      if (btn) { btn.dataset.ssAddedLabel = 'ADDED ✓'; btn.addEventListener('click', function () { addToCart([{ id: +card.getAttribute('data-variant'), quantity: size }], btn); }); }
    });
  }

  function once(sel, fn) {
    document.querySelectorAll(sel).forEach(function (el) { if (el.__ssInit) return; el.__ssInit = true; fn(el); });
  }
  function boot() {
    once('[data-ss-buybox]', initBuybox);
    once('[data-ss-purpose]', initDrawers);
    once('[data-ss-facts]', initFacts);
    once('[data-ss-timeline]', initTimeline);
    once('[data-ss-results]', initResults);
    once('[data-ss-g90-sec]', initG90);
    once('[data-ss-more]', initMore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
